import React, { SyntheticEvent } from "react";

import { IMaskInput } from "react-imask";

// Types
type MaskedInputProps = {
  mask: string;
  name?: string;
  readOnly?: boolean;
  value?: string | null;
  onChange: (event: SyntheticEvent, data: { name?: string; value: string }) => void;
};

const MaskedInput = (props: MaskedInputProps) => {
  const handleAccept = (value: string, maskRef: any, e?: InputEvent) => {
    if (e) {
      props.onChange(e as any, { name: props.name, value });
    }
  };

  return (
    <IMaskInput
      lazy={false} // แสดง placeholder ตลอดเวลา
      mask={props.mask}
      readOnly={props.readOnly}
      value={props.value ?? ""}
      autofix // แก้ไขค่าให้ถูกต้องอัตโนมัติ
      eager // อัพเดทค่าทันทีเมื่อพิม/ลบ
      unmask
      onAccept={handleAccept}
    />
  );
};

MaskedInput.displayName = "MaskedInput";

export default React.memo(MaskedInput);
